<app-expansion-panel
  [expansionPanelId]="selectId"
  [coverText]="coverText"
  [coverSpacing]="coverSpacing"
  [state]="disabled ? 'disabled' : 'default'"
>
  <ng-container ngProjectAs="[dropdown-content]">
    <div class="select-dropdown-content" [id]="selectId + '-select-dropdown'">
      @for (param of params; track param) {
        <div
          class="select-option"
          [class.selected]="value === param.value || value === param.title"
          [class.disabled]="param.disabled || false"
          (click)="handleChange(param)"
          (keydown.enter)="onKeyDownHandleChange(param)"
          tabindex="0"
          role="button"
          [id]="'select-option-' + params.indexOf(param)"
        >
          <span>{{ param.title }}</span>
          @if (value === param.value || value === param.title) {
            <app-icon
              phosphorClass="ph-check"
              [iconStyle]="Style.bold"
              [color]="Color.primary300"
              [size]="Size.small"
            ></app-icon>
          }
        </div>
      }
    </div>
  </ng-container>
</app-expansion-panel>
